export default __webpack_public_path__ + "static/media/pic3.8a42c9b6.jpg";